import styled from "styled-components";
import { media } from "../../theme/theme";

const FOOTER_DEFAULT_BREAKPOINT = 800;
const FOOTER_EXTENDED_BREAKPOINT = 1367;

export const V3FooterWrapper = styled.div<{ $maxWidth?: string, $useExtendedBreakpoint?: boolean }>`
    display: flex;
    max-width: ${({ $maxWidth }) => $maxWidth ? $maxWidth : "1056px"};
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    
    ${media.custom(414)} {
        align-items: center;
    }

    ${media.custom(FOOTER_DEFAULT_BREAKPOINT)} {
        flex-direction: ${({ $useExtendedBreakpoint }) => !$useExtendedBreakpoint ? "row" : undefined};
    }

    ${media.custom(FOOTER_EXTENDED_BREAKPOINT)} {
        flex-direction: ${({ $useExtendedBreakpoint }) => $useExtendedBreakpoint ? "row" : undefined};
    }

    > div {
        &:first-child {
            margin-bottom: 12px;

            ${media.custom(FOOTER_DEFAULT_BREAKPOINT)} {
                margin-bottom: ${({ $useExtendedBreakpoint }) => !$useExtendedBreakpoint ? "0px" : undefined};
            }

            ${media.custom(FOOTER_EXTENDED_BREAKPOINT)} {
                margin-bottom: ${({ $useExtendedBreakpoint }) => $useExtendedBreakpoint ? "0px" : undefined};
            }
        }
    }

    @media print {
        display: none;
    }
`;

export const V3FooterContainer = styled.div`
    padding: 30px 0;
`;

export const V3LeftS = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 25px;
        }
    }
`;

export const V3RightS = styled.div<{ $useExtendedBreakpoint?: boolean }>`
    display: flex;
    align-items: center;
    flex-shrink: 0;

    > div {
        &:not(:last-child) {
            margin-right: 30px;
        }
    }
`;


export const BuiltFooterBr = styled.br`
    display: block;

    ${media.custom(490)} {
        display: none;
    }
`;